import {Component, Input, OnInit} from '@angular/core';
import {IconsEnum} from '../../../shared-icons/models/icons.enum';

@Component({
    selector: 'app-page-header-old',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    standalone: false
})
export class PageHeaderComponent implements OnInit {

  readonly icons = IconsEnum;

  @Input() title: string;


  ngOnInit(): void {
    if (!this.title) {
      this.title = '<Page Title>';
    }
  }

}
